import { Text, Box, HStack, Button, Hidden, View } from "native-base";
import { FcMinus } from "react-icons/fc";
import { AiOutlinePlus } from "react-icons/ai";
import colors from "theme/colors";
import styles from "./styles";

const NumberedSummaryBox = (props) => {
  return (
    <Box style={styles.box} overflow="hidden" {...props}>
      <HStack
        justifyContent="space-between"
        alignItems="center"
        style={styles.titleGroup}
      >
        <HStack alignItems="center">
          <View
            h="24px"
            w="24px"
            borderRadius="12px"
            bg={colors.secondary.orchid}
            alignItems="center"
            justifyContent="center"
            space={2}
            mr="12px"
          >
            <Text color={colors.neutral.cotton}>{props?.number}</Text>
          </View>
          <Text variant="sm-bold" style={styles.title}>
            {props.title}
          </Text>
        </HStack>
        <Hidden from="md">
          {props.shouldMinimize && (
            <Button
              variant="ghost"
              onPress={() => props.setMinimize(!props.minimize)}
              h="5px"
              alignItems="center"
            >
              {props.minimize ? (
                <AiOutlinePlus size="25px" />
              ) : (
                <FcMinus size="25px" />
              )}
            </Button>
          )}
        </Hidden>
      </HStack>
      {props.children}
    </Box>
  );
};

export default NumberedSummaryBox;
